// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
import { Guid } from 'guid-typescript';
import { AppEnvironmentConfig } from './app-environment-config.model';
import { AppEnvironment } from './app-environment.enum';

export const defaultEnvironment: AppEnvironmentConfig = {
    type: AppEnvironment.Development,
    name: AppEnvironment.Development,
    requestTimeout: 300000,
    baseUrl: window.location.origin + '/app',
    authIssuerUrl: 'https://develop.dis-apeer.com/api/identity',
    websocketOrigin: window.location.origin + '/api/notifications',
    signupUrl:
        'https://id-ip-stage.zeiss.com/OAuth/Authorize?p=B2C_1A_ZeissIdSignin&client_id=62d7f1c1-5abe-47be-ad77-75ca5eda5b14&redirect_uri=https%3A%2F%2Fid-stage.zeiss.com%2Fsignin-oidc&response_type=id_token&scope=openid%20profile&response_mode=form_post',
    showGlobalErrorMessages: false,
    landingPageUrl: '/home/',
    machineLearningConfig: {
        dataPreparationModuleIds: [Guid.parse('b2c1cb81-0026-4dfb-93ba-d44cd378217c'), Guid.parse('919da74f-a59a-49c3-9898-118943d2699a')],
        datasetValidationModuleIds: [Guid.parse('a40f0708-9c6d-45ef-93e5-e690d061f13a'), Guid.parse('7af04a68-9cba-4bd0-8af8-e826993621e4')],
        apeerMlModuleIds: [Guid.parse('e70bbd84-ba1f-49d1-988c-25507e88f82e'), Guid.parse('a1ca563a-0ce1-49cb-919c-7be495427adf')],
    },
    /**
     * Turn this on to see regular log messages showing ngZone tasks.
     */
    ngZoneDebugging: false,
    defaultMaxFileSizeInBytes: 1000000 * 1024 * 1024,
    machineLearningMaxFileSizeInBytes: 12 * 1024 * 1024 * 1024,
    arivisUrlPrefix: 'https://' + window.location.host,
    aiRegistryBaseUrl: `https://ai-registry.${window.location.host.replace('www.', '')}`,
    workflowInputSettingsJsonReleaseDate: new Date('2022-01-11T00:00:00Z'),
    mixpanelToken: 'ffa57103fedb4c951734a3556f8e7e89',
};
